module.exports = __webpack_public_path__ + "static/media/local_store.e168351c.jpeg";